/*
 * Copyright (c) 2024. Bolmate B.V.
 */

import IDate from '@dvrd/idate';

import {ReviewSalesPeriod, ReviewTab} from './interfaces';

type AnalyticsMem = {
    period: ReviewSalesPeriod | null;
    periodFrom: IDate | null;
    periodTo: IDate | null;
    tab: ReviewTab | null;
    tablePage: number;
    tableSearch: string | null;
    tableLimit: number | null;
    tableSort: string | null;
    tableSortOrder: number | null;
};

let analyticsMem: AnalyticsMem = {
    period: null,
    periodFrom: null,
    periodTo: null,
    tab: null,
    tablePage: 0,
    tableSearch: null,
    tableLimit: null,
    tableSort: null,
    tableSortOrder: null
};

export function setReviewAnalyticsMemValue(key: keyof AnalyticsMem, value: any) {
    analyticsMem[key] = value as never;
}

export function getReviewAnalyticsMemValue(key: keyof AnalyticsMem): any {
    return analyticsMem[key];
}

export function getReviewAnalyticsMem(): AnalyticsMem {
    return analyticsMem;
}

export function resetReviewAnalyticsMem() {
    analyticsMem = {
        period: ReviewSalesPeriod.THIRTY_DAYS,
        periodFrom: null,
        periodTo: null,
        tab: ReviewTab.FEED,
        tablePage: 0,
        tableSearch: null,
        tableLimit: null,
        tableSort: null,
        tableSortOrder: null
    };
}
